module.exports = __webpack_public_path__ + "img/angst-behandeling-foto.f421145d.jpg";